export const HOME_DEEPLINK = 'bancointer://home?refresh=true'
